import { PayloadAction } from '@reduxjs/toolkit';

import { DisabledSpread, EditorState } from 'editor/src/store/editor/types';

const setDisabledSpreadsReducer = (state: EditorState, action: PayloadAction<DisabledSpread[]>) => {
  state.disabledSpreads = action.payload;
};

export default setDisabledSpreadsReducer;
